import React from "react";
import { Skeleton, Stack } from "@mui/material";

export const PrinterListSkeleton = () => {
  const props = { variant: "rounded", height: 30 };
  return (
    <Stack gap="2px" width="100%" padding="0px 5px">
      <Skeleton {...props} />
      <Skeleton {...props} />
      <Skeleton {...props} />
    </Stack>
  );
};

export default PrinterListSkeleton;
